import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { mapActions, mapState } from "vuex";

export default {
    beforeMount() {
        this.$store.dispatch('adminAppEditUser/fetchUserProfile', {
            'editedUserId': this.$route.params.userId,
        });
    },
    components: {
        top,
        navigation,
        bottom
    },
    computed: {
        ...mapState('adminAppEditUser', {
            editedUserLoaded: state => state.editedUserLoaded,
            //email: state => state.editedUser.email,
            customProfileId: state => state.editedUser.custom_profile_id,
            id: state => state.editedUser.id,
            profileLink: state => state.editedUser.profile_link,
            accountBanned: state => state.editedUser.is_account_banned,
            accountDeleted: state => state.editedUser.is_account_deleted,
            accountSuspended: state => state.editedUser.is_account_suspended,
            accountInDeletionMode: state => state.editedUser.is_account_in_deletion_mode,
            accountOAuth: state => state.editedUser.is_account_o_auth,
            createdAt: state => state.editedUser.created_at,
            totalLikes: state => state.editedUser.stats_total_likes,
            totalVisitsReceived: state => state.editedUser.stats_visits_received,
            totalVisitsEmitted: state => state.editedUser.stats_visits_emitted,
            totalPoints: state => state.editedUser.stats_points,
            totalReferrals: state => state.editedUser.stats_referral_count,
        }),
        nickname: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.nickname;
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserField", {
                    fieldToEdit: 'nickname',
                    fieldToEditValue: value,
                });
            }
        },
        hashtagN1: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.hashtags['number1'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserHashtags", {
                    hashtagToEdit: 'number1',
                    hashtagToEditValue: value,
                });
            }
        },
        hashtagN2: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.hashtags['number2'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserHashtags", {
                    hashtagToEdit: 'number2',
                    hashtagToEditValue: value,
                });
            }
        },
        hashtagN3: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.hashtags['number3'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserHashtags", {
                    hashtagToEdit: 'number3',
                    hashtagToEditValue: value,
                });
            }
        },
        phone: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.phone;
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserField", {
                    fieldToEdit: 'phone',
                    fieldToEditValue: value,
                });
            }
        },
        about: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.about;
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserField", {
                    fieldToEdit: 'about',
                    fieldToEditValue: value,
                });
            }
        },
        themeDark: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.preferences['preferences_dark_theme_enabled'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserPreferences", {
                    fieldToEdit: 'preferences_dark_theme_enabled',
                    fieldToEditValue: value,
                });
            }
        },
        emailPublic: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.preferences['preferences_display_publicly_email'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserPreferences", {
                    fieldToEdit: 'preferences_display_publicly_email',
                    fieldToEditValue: value,
                });
            }
        },
        introDone: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.is_intro_done;
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserField", {
                    fieldToEdit: 'is_intro_done',
                    fieldToEditValue: value,
                });
            }
        },
        notificationLike: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_like'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_like',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        notificationForVisitNfc: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_visit_nfc'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_visit_nfc',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        notificationForVisitQrCode: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_visit_qrcode'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_visit_qrcode',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        notificationForVisitSearch: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_visit_search'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_visit_search',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        notificationForVisitUrl: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_visit_url'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_visit_url',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        notificationForReferral: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.notifications_preferences['notifications_for_referral'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNotificationsPreferences", {
                    notificationPreferenceToEdit: 'notifications_for_referral',
                    notificationPreferenceToEditValue: value,
                });
            }
        },
        networkFacebook: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_facebook'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_facebook',
                    networkToEditValue: value,
                });
            }
        },
        networkTwitter: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_twitter'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_twitter',
                    networkToEditValue: value,
                });
            }
        },
        networkSnapchat: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_snapchat'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_snapchat',
                    networkToEditValue: value,
                });
            }
        },
        networkInstagram: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_instagram'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_instagram',
                    networkToEditValue: value,
                });
            }
        },
        networkTwitch: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_twitch'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_twitch',
                    networkToEditValue: value,
                });
            }
        },
        networkTiktok: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_tiktok'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_tiktok',
                    networkToEditValue: value,
                });
            }
        },
        networkVimeo: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_vimeo'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_vimeo',
                    networkToEditValue: value,
                });
            }
        },
        networkYoutube: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_youtube'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_youtube',
                    networkToEditValue: value,
                });
            }
        },
        networkGithub: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_github'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_github',
                    networkToEditValue: value,
                });
            }
        },
        networkLinkedin: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_linkedin'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_linkedin',
                    networkToEditValue: value,
                });
            }
        },
        networkWebsite: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_website'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_website',
                    networkToEditValue: value,
                });
            }
        },
        networkPaypal: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_paypal'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_paypal',
                    networkToEditValue: value,
                });
            }
        },
        networkXboxlive: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_xboxlive'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_xboxlive',
                    networkToEditValue: value,
                });
            }
        },
        networkPsn: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_psn'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_psn',
                    networkToEditValue: value,
                });
            }
        },
        networkSteam: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_steam'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_steam',
                    networkToEditValue: value,
                });
            }
        },
        networkOrigin: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_origin'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_origin',
                    networkToEditValue: value,
                });
            }
        },
        networkBattlenet: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_battlenet'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_battlenet',
                    networkToEditValue: value,
                });
            }
        },
        networkUplay: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_uplay'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_uplay',
                    networkToEditValue: value,
                });
            }
        },
        networkEpicgames: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_epicgames'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_epicgames',
                    networkToEditValue: value,
                });
            }
        },
        networkSpotify: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_spotify'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_spotify',
                    networkToEditValue: value,
                });
            }
        },
        networkSoundcloud: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_soundcloud'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_soundcloud',
                    networkToEditValue: value,
                });
            }
        },
        networkDeezer: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_deezer'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_deezer',
                    networkToEditValue: value,
                });
            }
        },
        networkApplemusic: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_applemusic'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_applemusic',
                    networkToEditValue: value,
                });
            }
        },
        networkBelievemusic: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_believemusic'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_believemusic',
                    networkToEditValue: value,
                });
            }
        },
        networkSkype: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_skype'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_skype',
                    networkToEditValue: value,
                });
            }
        },
        networkTeams: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_teams'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_teams',
                    networkToEditValue: value,
                });
            }
        },
        networkDiscord: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_discord'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_discord',
                    networkToEditValue: value,
                });
            }
        },
        networkDeviantart: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_deviantart'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_deviantart',
                    networkToEditValue: value,
                });
            }
        },
        networkPinterest: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_pinterest'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_pinterest',
                    networkToEditValue: value,
                });
            }
        },
        networkDribbble: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_dribbble'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_dribbble',
                    networkToEditValue: value,
                });
            }
        },
        networkTipeee: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_tipeee'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_tipeee',
                    networkToEditValue: value,
                });
            }
        },
        networkPatreon: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_patreon'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_patreon',
                    networkToEditValue: value,
                });
            }
        },
        networkKickstarter: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_kickstarter'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_kickstarter',
                    networkToEditValue: value,
                });
            }
        },
        networkGofundme: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_gofundme'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_gofundme',
                    networkToEditValue: value,
                });
            }
        },
        networkLeetchi: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_leetchi'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_leetchi',
                    networkToEditValue: value,
                });
            }
        },
        networkUtip: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_utip'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_utip',
                    networkToEditValue: value,
                });
            }
        },
        networkEbay: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_ebay'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_ebay',
                    networkToEditValue: value,
                });
            }
        },
        networkLeboncoin: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_leboncoin'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_leboncoin',
                    networkToEditValue: value,
                });
            }
        },
        networkVinted: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_vinted'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_vinted',
                    networkToEditValue: value,
                });
            }
        },
        networkOnlyfans: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_onlyfans'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_onlyfans',
                    networkToEditValue: value,
                });
            }
        },
        networkMym: {
            get() {
                return this.$store.state.adminAppEditUser.editedUser.networks['network_mym'];
            },
            set(value) {
                this.$store.commit("adminAppEditUser/setEditedUserNetworks", {
                    networkToEdit: 'network_mym',
                    networkToEditValue: value,
                });
            }
        },
    },
    methods: {
        resetUserAvatarAndCover(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/resetUserAvatarAndCover');
        },
        resetUserInformations(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/resetUserInformations');
        },
        userBanOrUnban(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/userBanOrUnban');
        },
        updateNetworks(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/updateEditedUserNetworks');
        },
        updateInformations(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/updateEditedUserInformations');
        },
        retrieveEmail(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppEditUser/retrieveUserEmail');
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-edit-user/master/app-edit-user.js